export default {
  deliveryNotScheduled: {
    status: "not-scheduled",
    statusColor: "disabled",
    message: "Delivery not scheduled",
  },
  deliveryCompleted: {
    status: "completed",
    statusColor: "success.dark",
    message: "Delivery completed",
  },
};
